import { render, staticRenderFns } from "./TokopediaIntegration.vue?vue&type=template&id=501d58a3"
import script from "./TokopediaIntegration.vue?vue&type=script&lang=js"
export * from "./TokopediaIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports